import { Component } from '@angular/core';
import { MaxLength } from 'src/app/enums/enums';
import { SharedService } from 'src/app/services/shared.service';

@Component({
  selector: 'app-forgot-password',
  templateUrl: './forgot-password.component.html',
  styleUrls: ['./forgot-password.component.scss']
})
export class ForgotPasswordComponent {
  IsEmailSubmiteed = false;
  Email: string = '';
  OTPMaxLength = MaxLength.OTP;
  OTP: number | null = null;

  constructor(public sharedService: SharedService) {}

  SubmitEmail() {
    console.log(this.Email);
    this.IsEmailSubmiteed = true;
  }

  SubmitOTP() {
    console.log(this.OTP);
    this.IsEmailSubmiteed = false;
  }
}
